import { API_URL } from '_constants';
import { useSelectedCoopItem } from './hooks';

/**
 * @returns true if not in production environment, or if user is in either Bjergsted Terrasse, Bekkestua Have, qa borettslaget or solbakken terrasse
 */
const useParkingSharingEnabled = () => {
    const apiUrl = API_URL('no');
    const selectedCoopItem = useSelectedCoopItem();
    return !apiUrl.includes('app.heime.com') || [245, 239, 39, 121].includes(selectedCoopItem?.id ?? 0);
};

export default useParkingSharingEnabled;
